module.exports = "/virtual-football-league/img/amblems/right/logos/SwanCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/SwanCity.png
// module id = 2231
// module chunks = 4